import { NgModule } from '@angular/core';
import { MenuComponent } from './menu/menu.component';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { IonicModule } from '@ionic/angular';
import { HeaderPublicoComponent } from './header-publico/header-publico.component';

@NgModule({
    declarations: [
        MenuComponent,
        HeaderPublicoComponent,
    ],
    providers: [],
    imports: [
        CommonModule,
        IonicModule,
        PipesModule,
    ],
    exports: [
        MenuComponent,
        HeaderPublicoComponent,
    ],
})

export class PagesComponentsModule { }
